<div class="content">
  <evc-nav-button type="cta" size="xxl" variant="round" (click)="useApplicationFileManager ? showFileManager() : importbutton.click()" *callToAction>
    <span class="top-cta-label">
      {{ "offlineReportTemplate.import" | translate }}
    </span>
    <evc-svg-icon size="md" [icon]="'plus'"></evc-svg-icon>
  </evc-nav-button>

  <div class="settings-title-container">
    <h1>{{ "offlineReportTemplate.title" | translate }}</h1>
  </div>

  <input #importbutton accept=".zip" hidden type="file" (change)="importReportTemplate($event); importbutton.value = ''" />

  @if (isReportTemplateExists) {
    <p-table [value]="reportTemplateListsDataSource" [responsiveLayout]="'scroll'" styleClass="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "offlineReportTemplate.templateName" | translate }}</th>
          <th>{{ "offlineReportTemplate.lastUpdateDate" | translate }}</th>
          <th>{{ "offlineReportTemplate.model" | translate }}</th>
          <th></th>
          <!-- Actions column -->
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.name }}</td>

          <td class="date-row">{{ row.lastUpdateDate | date: "yyyy/MM/dd" }}</td>

          <td class="subject-model-row">
            <p-multiSelect
              [options]="subjectModelListItems"
              [(ngModel)]="row.subjectModelIds"
              optionLabel="name"
              optionValue="id"
              (onChange)="changeTargetSubjectModels($event, row)"
              appendTo="body"
              filter="false"
            >
              <ng-template let-option pTemplate="item">
                <span class="option">
                  {{ option.name }}
                </span>
              </ng-template>
            </p-multiSelect>
          </td>

          <td>
            <div class="actions">
              <evc-nav-button
                class="tags-action-button delete-button black-icon"
                [type]="'tertiary'"
                [size]="'sm'"
                [variant]="'semi'"
                [disabled]="row.isOfflineData"
                (click)="viewPdfPreview(row)"
              >
                {{ "offlineReportTemplate.view" | translate }}
              </evc-nav-button>

              <evc-nav-button
                class="tags-action-button delete-button black-icon"
                [type]="'tertiary'"
                [size]="'sm'"
                [variant]="'semi'"
                (click)="exportTemplate(row)"
              >
                {{ "offlineReportTemplate.export" | translate }}
              </evc-nav-button>

              <evc-nav-button
                class="tags-action-button delete-button black-icon"
                [type]="'tertiary'"
                [size]="'sm'"
                [variant]="'semi'"
                (click)="isOnPremiseMode ? deleteOnPremiseReportTemplate(row) : deleteReportTemplate(row)"
              >
                {{ "offlineReportTemplate.delete" | translate }}
              </evc-nav-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }

  @if (!isReportTemplateExists) {
    <div fxLayout="row" fxLayoutAlign="center none">
      {{ "offlineReportTemplate.reportTemplatesNotFound" | translate }}
    </div>
  }
</div>

@if (pdfUrl) {
  <evc-modal [showReduceButton]="false" (closeModal)="closePdf()" [height]="'850px'" [width]="'900px'">
    <div modal-content>
      <iframe [src]="pdfUrl" width="100%" height="700px"></iframe>
    </div>
  </evc-modal>
}
